import React from 'react'
import './styles.scss'

interface OptionPillGroupProps {
  options: {
    label: string
    value: string
  }[]
  selected: string
  onChange: (value: string) => void
}

const OptionPillGroup: React.FC<OptionPillGroupProps> = ({
  options,
  selected,
  onChange,
}) => {
  return (
    <div className="option-pill-group">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`pill ${selected === option.value ? 'selected' : ''}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default OptionPillGroup
